import { c as _c } from "react/compiler-runtime";
import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Placeholder from 'components/consumer/Placeholder';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import CardCarousel from 'components/consumer/image-slider-standard/components/CardCarousel';
import JBImage from 'components/essentials/JBImage';
import ToggleCTALinkButtonWithoutDesignServices from 'components/essentials/ToggleCTALinkButtonWithoutDesignServices';
import Link from 'components/consumer/Link';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useScreen from 'hooks/useScreen';
import useIsBrowser from 'hooks/useIsBrowser';
import { addMainImages } from '../collections-page/withState';
import EmblaCarousel, { EmblaSlide } from '../image-slider-standard/components/EmblaCarousel';
import CollectionsContext from './CollectionsContext';
import { GET_COLLECTIONS_LITE } from './query';
const ConsumerCollectionsSlider = props => {
  const $ = _c(28);
  const isBrowser = useIsBrowser();
  const {
    config: t0
  } = props;
  const {
    heading,
    subHeading,
    toggleInputType
  } = t0;
  const isSubHeading = subHeading && subHeading.content;
  const contextData = useContext(CollectionsContext);
  const hasContextData = contextData != null;
  const t1 = hasContextData || !isBrowser;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      skip: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: apolloData,
    error: apolloError,
    loading: apolloLoading
  } = useSuspenseQuery(GET_COLLECTIONS_LITE, t2);
  const data = hasContextData ? contextData : apolloData;
  const error = hasContextData ? null : apolloError;
  const loading = hasContextData ? false : apolloLoading;
  const readyToShowContent = hasContextData || isBrowser;
  const collections = !error && !loading && data?.getCollections && data.getCollections.collections.length ? addMainImages(data.getCollections.collections.map(_temp)) : [];
  const {
    isDesktop,
    isMobile
  } = useScreen();
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      query: "(max-width: 1280px)"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isNotCinema = useMediaQuery(t3);
  const imageSize = isBrowser && isDesktop && isNotCinema ? 390 : 340;
  let t4;
  if ($[3] !== imageSize) {
    t4 = {
      width: imageSize,
      height: imageSize,
      trim: "auto"
    };
    $[3] = imageSize;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const imageSizeProps = t4;
  let t5;
  if ($[5] !== imageSizeProps) {
    t5 = () => Array.from(Array(4).keys()).map(i => <button type="button" className={classNames("block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]", "flex-[1_1] flex-col justify-between items-center min-w-[80%] sm:min-w-[33.333%] lg:min-w-[25%]", "[&_img]:object-cover [&_img]:block")} key={i} to="#" aria-label="Loading"><div className="bg-gray-light8"><Placeholder loading={true} type="rect" style={{
          ...imageSizeProps,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></div><h5 className="mt-3 mb-[.312rem] text-xl font-bold"><Placeholder loading={true} style={{
          width: 134,
          height: 22,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></h5><div className="text-sm text-gray"><Placeholder loading={true} style={{
          width: "100%",
          height: 20,
          marginLeft: "5px",
          marginRight: "5px"
        }} /><Placeholder loading={true} style={{
          width: "100%",
          height: 20,
          marginLeft: "5px",
          marginRight: "5px"
        }} /></div></button>);
    $[5] = imageSizeProps;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const getLoaders = t5;
  let t6;
  if ($[7] !== imageSizeProps) {
    t6 = collectionsToRender => collectionsToRender.map(collection_0 => {
      const imageSrc = collection_0.images[0] && collection_0.images[0].url;
      const collectionName = collection_0.name.replace(" Collection", "");
      const slideContent = <Link className={classNames("block float-left w-full !text-gray no-underline hover:!no-underline focus-visible:rounded-[5px] focus-visible:p-[5px] focus-visible:outline-offset-[-2px]", "flex-[1_1] flex-col justify-between items-center min-w-[80%] sm:min-w-[33.333%] xl:min-w-[25%]", "[&_img]:object-cover [&_img]:block", "mx-0 px-0")} key={collection_0.id} to={collection_0.url} aria-label={collectionName}><JBImage alt="" {...imageSizeProps} src={imageSrc} /><h3 className="mt-3 mb-[.312rem] text-xl font-bold">{collectionName}</h3><p className="text-sm text-gray">{collection_0.category_description || collection_0.category_meta_description}</p></Link>;
      return <EmblaSlide className="flex-grow flex-shrink basis-[80%] sm:basis-1/3 lg:basis-1/4 sm:pl-2.5 sm:first:pl-0" key={collection_0.id}>{slideContent}</EmblaSlide>;
    });
    $[7] = imageSizeProps;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const getChildren = t6;
  const T0 = FixedWidthContainer;
  const t7 = true;
  const t8 = "ConsumerCollectionsSlider";
  const t9 = "min-h-[500px] mx-0 my-6 [&_a]:no-underline [&_.slider-control-centerright]:!top-[35%] [&_.slider-control-centerleft]:!top-[35%] [&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]";
  const t10 = heading && heading.content || "";
  let t11;
  if ($[9] !== t10) {
    t11 = <h2 className="max-[767px]:pl-5 max-[767px]:pr-5 m-0 text-2xl font-bold">{t10}</h2>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== isSubHeading || $[12] !== subHeading) {
    t12 = isSubHeading && <p className="max-[767px]:pl-5 max-[767px]:pr-5 font-normal">{subHeading.content}</p>;
    $[11] = isSubHeading;
    $[12] = subHeading;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== getLoaders || $[15] !== readyToShowContent) {
    t13 = !readyToShowContent && <CardCarousel imageHeight={350} imageWidth={350} navType="Button" variant="collections-slider" visibleSlides={4}>{getLoaders()}</CardCarousel>;
    $[14] = getLoaders;
    $[15] = readyToShowContent;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const t14 = readyToShowContent && !error && <EmblaCarousel className="gap-0 sm:gap-2.5 px-5 md:px-0" slideSpacing={isMobile ? "0px" : "10px"} variant="collections-slider">{getChildren(collections)}</EmblaCarousel>;
  let t15;
  if ($[17] !== toggleInputType) {
    t15 = !!toggleInputType && <div className="max-[767px]:pl-5 max-[767px]:pr-5"><ToggleCTALinkButtonWithoutDesignServices toggleInputType={toggleInputType} linkClassName="!pl-0" /></div>;
    $[17] = toggleInputType;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t11 || $[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
    t16 = <div className={t9}>{t11}{t12}{t13}{t14}{t15}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== T0 || $[26] !== t16) {
    t17 = <T0 noMobilePadding={t7} className={t8}>{t16}</T0>;
    $[25] = T0;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};
ConsumerCollectionsSlider.propTypes = {
  config: PropTypes.shape({
    heading: PropTypes.shape({
      content: PropTypes.string
    }),
    subHeading: PropTypes.shape({
      content: PropTypes.string
    }),
    toggleInputType: PropTypes.object
  })
};
export default ConsumerCollectionsSlider;
function _temp(collection) {
  if (collection.url && !collection.url.startsWith("/")) {
    return {
      ...collection,
      url: `/${collection.url}`
    };
  }
  return collection;
}